import React from "react";

const STATUS_COLORS = {
  new: "#1677ff",
  "pending-review": "#faad14",
  pending: "#faad14",
  approved: "#52c41a",
  active: "#52c41a",
  declined: "#ff4d4f",
  suspended: "#faad14",
  deleted: "#ff4d4f",
};

const STATUS_LABELS = {
  "pending-review": "PENDING REVIEW",
  deleted: "USER DELETED",
};

const UserStatusBadge = ({ status, color, label }) => {
  const normalizedStatus = status?.toLowerCase();
  const displayLabel =
    label ||
    STATUS_LABELS[normalizedStatus] ||
    normalizedStatus?.toUpperCase() ||
    "N/A";

  return (
    <span className="user-status-badge">
      <span
        className="user-status-badge__dot"
        style={{ "--status-color": color || STATUS_COLORS[normalizedStatus] || "#bfbfbf" }}
      />
      <span>{displayLabel}</span>
    </span>
  );
};

export default UserStatusBadge;
